module.exports = __webpack_public_path__ + "static/media/artical_IMG.48d03c63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/artical_IMG.jpg
// module id = 76
// module chunks = 0